<template>
  <div style="border-top: 1px solid rgba(0, 0, 0, 0.12); border-bottom: 1px solid rgba(0, 0, 0, 0.12);">
    <v-row class="pl-3 pb-1" no-gutters>
      <span> {{ $t("admin.lblViewAssignedRole") }} </span>
    </v-row>
    <v-row class="pl-3 pb-3 mx-2" no-gutters>
      <a-data-table
        v-model="selectedMeetingType"
        :headers="headers"
        :items="roleAssignedList"
        class="elevation-1"
        item-key="meeting_type_id"
        hide-default-footer
        :no-data-text="$t('noData')"
        :loading-text="$t('LoaderText')"
        mobile-breakpoint="0"
        disable-pagination
        dense
        single-select
        fixed-header
        height="130px"
      >
        <template v-slot:[`header.meetingType`]="{ header }">
          <span class="header-text"> {{ header.text }}</span>
        </template>
        <template v-slot:[`header.role`]="{ header }">
          <span class="header-text"> {{ header.text }} </span>
        </template>
        <template v-slot:item="{ item, isSelected, select }">
          <tr
            style="cursor: pointer"
            :class="isSelected ? 'secondary' : ''"
            @click="toggle(isSelected, select, item)"
          >
            <td>{{ item.meetingType }}</td>
            <td>{{ item.role }}</td>
          </tr>
        </template>
      </a-data-table>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MeetingTypeAssignRoleTable",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    roleAssignedList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedFiles: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('admin.lblMeetingType'),
          value: "meetingType",
          align: "left",
          class: "header",
        },
        {
          text: this.$t('admin.lblAssignedRole'),
          value: "role",
          align: "left",
          class: "header",
        },
      ]
    },
    selectedMeetingType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
  },
  methods: {
    toggle(isSelected, select, item) {
      select(!isSelected);
      this.$emit("roelSelect", item);
    },
  },
};
</script>

<style scoped>
tr.v-data-table__selected {
  background: #7d92f5 !important;
}
</style